<template>
    <router-view :key="$route.fullPath"></router-view>
</template>

<script>
import userClient from '@/api/user';
export default {
    name: 'MosoStore',
    data: function() {
        return {

        };
    },

    created: function() {
        this.checkUser();
    },

    methods: {
        /**
         * check if there is valid token and user
         */
        checkUser: function() {
            const tokenData = this.$store.getToken();
            // At lease 1 hour alive
            if (tokenData && +(tokenData.expires) - Date.now() >= 3600000) {
                userClient.getProfile().then(resp => {
                    const user = resp.data.data;
                    if (user) {
                        this.$store.saveUser(user);
                    }
                });
            } else {
                this.$store.removeUser();
                this.$store.removeToken();
            }
        },
    },
};
</script>
